import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
export function AppLayout() {
  return <div className="flex h-screen overflow-hidden bg-gray-50 font-sans" data-id="element-166">
      <Sidebar data-id="element-167" />
      <div className="flex flex-col flex-1 w-0 overflow-hidden" data-id="element-168">
        <Header data-id="element-169" />
        <main className="flex-1 relative overflow-y-auto focus:outline-none" data-id="element-170">
          <div className="py-6 px-4 sm:px-6 md:px-8 max-w-7xl mx-auto" data-id="element-171">
            <Outlet data-id="element-172" />
          </div>
        </main>
      </div>
    </div>;
}